import React, { useCallback, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { apiChangeDonationAbility } from 'src/api/account/organizer';
import { ConfirmContext } from 'src/containers/Common';
import { DonationPageListItemType } from 'src/models/DonationPage/List';
import { Enums } from 'src/models/enums';
import { anyRequestStart } from 'src/store/anyRequest/slice';
import { useTHelper } from 'src/utils/i18n';

type Props = {
  hideModal: () => void;
  uniqueChangeAvailabilityId: string;
  item: DonationPageListItemType | null;
};

export const DonationPageListModalTurnOnOff: React.FC<Props> = ({
  hideModal,
  uniqueChangeAvailabilityId,
  item,
}: Props) => {
  const confirm = useContext(ConfirmContext);

  const dispatch = useDispatch();

  const tHelper = useTHelper('donationPageList.modals.turnonoff');

  const onChangeAvailability = useCallback(() => {
    if (item) {
      const data: Parameters<typeof apiChangeDonationAbility>[0] = {
        PermanentUrl: item.PermanentUrl,
        IsDonationAllowed: item.DonationPageDisplayingStatusCode === Enums.campaigns.StatusCode.Off,
      };

      dispatch(
        anyRequestStart({
          data,
          apiFunction: apiChangeDonationAbility,
          uniqueId: uniqueChangeAvailabilityId,
        })
      );
    }
  }, [dispatch, item, uniqueChangeAvailabilityId]);

  useEffect(() => {
    if (item?.DonationPageDisplayingStatusCode === Enums.campaigns.StatusCode.Off) {
      onChangeAvailability();
      hideModal();
    } else {
      confirm(
        {
          header: tHelper('header'),
          body: tHelper('body', {
            lowerDonations: item?.ContributionTerminology.Plural.toLowerCase() || '',
          }),
          successBtnText: tHelper('successBtnText'),
        },
        () => {
          onChangeAvailability();
          hideModal();
        },
        hideModal
      );
    }
  }, [
    confirm,
    hideModal,
    item?.ContributionTerminology.Plural,
    item?.DonationPageDisplayingStatusCode,
    onChangeAvailability,
    tHelper,
  ]);

  return null;
};
